export default __webpack_public_path__ + "67c9ca3c8c820709268ffabb23147154.svg";